<template>
	<div id="pc" @click="clickDocument">
		<header style="color: #fff;" :class="$i18n.locale == 'cn' ? 'topheader topheadercn' : 'topheader' " v-if="commonfontColor == 'font_white'">
			<div class="toheader_left">
				<div class="headerlogo" @click="gotoIndex(1)"><img src="../assets/logowhite.png" ></div>
				<span @click="gotoIndex(1)" :class="curPage >= 1 && curPage < 7 ? 'curBorderW': ''">{{$t('header.about')}}</span>
				<span @click="gotoIndex(7)" :class="curPage == 7 ? 'curBorderW': ''">{{$t('header.game')}}</span>
				<span @click="gotoIndex(8)" :class="curPage == 8 ? 'curBorderW': ''">{{$t('header.contact')}}</span>
        <span><a href="http://ir.gamehaus.com/" target="_blank" style="color: #fff;">Investors</a></span>
        
			</div>
			<!-- <p class="right_text" @click="changeLangue">
				<span>
					{{$i18n.locale == 'cn' ? 'ENG' : 'CN'}}
				</span>
			</p> -->
		</header>
		<header style="color: #000;" :class="$i18n.locale == 'cn' ? 'topheader topheadercn' : 'topheader' " v-if="commonfontColor == 'font_black'">
			<div class="toheader_left">
				<div class="headerlogo" @click="gotoIndex(1)">
					<img src="../assets/blacklogo.png" ></div>
				<span @click="gotoIndex(1)" :class="curPage >= 1 && curPage < 7 ? 'curBorderB': ''">{{$t('header.about')}}</span>
				<span @click="gotoIndex(7)" :class="curPage == 7 ? 'curBorderB': ''">{{$t('header.game')}}</span>
				<span @click="gotoIndex(8)" :class="curPage == 8 ? 'curBorderB': ''">{{$t('header.contact')}}</span>
        <span><a href="http://ir.gamehaus.com/" target="_blank" style="color: #000;">Investors</a></span>
			</div>
			<!-- <p class="right_text" @click="changeLangue">
				<span>
					{{$i18n.locale == 'cn' ? 'ENG' : 'CN'}}
				</span>
			</p> -->
		</header>
		 <full-page ref="slideContainer" :options="options" @leave="beforeLoad">
		      <div class="section">
				  <Banner1 :curpage="curPage" :aniDownUp="aniDownUp"></Banner1>
			  </div>
		      <div class="section">
				  <Banner2 :curpage="curPage" :aniDownUp="aniDownUp"></Banner2>
			  </div>
		      <div class="section">
				  <Banner3 :curpage="curPage" :aniDownUp="aniDownUp"></Banner3>
			  </div>
			  <div class="section">
					<Banner4 :curpage="curPage" :aniDownUp="aniDownUp"></Banner4>
			  </div>
			  <div class="section">
			  		<Banner5 :curpage="curPage" :aniDownUp="aniDownUp"></Banner5>
			  </div>
			  <div class="section">
			  		<Banner6 @goPage="gotoIndex" :curpage="curPage"></Banner6>
			  </div>
			  <div class="section">
			  		<Banner7 :curpage="curPage" :aniDownUp="aniDownUp"></Banner7>
			  </div>
			  <div class="section">
			  		<Banner8 :curpage="curPage" :aniDownUp="aniDownUp"></Banner8>
			  </div>
		</full-page>
	</div>
</template>

<script>
	import { SlideContainer, SlidePage } from 'vue-slidepage'
	import Banner1 from './pc/banner1.vue'
	import Banner2 from './pc/banner2.vue'
	import Banner3 from './pc/banner3.vue'
	import Banner4 from './pc/banner4.vue'
	import Banner5 from './pc/banner5.vue'
	import Banner6 from './pc/banner6.vue'
	import Banner7 from './pc/banner7.vue'
	import Banner8 from './pc/banner8.vue'
	// Banner2
	import { Slider, SliderItem } from 'vue-easy-slider'
	export default {
		components: {	
		    SlideContainer,
		    SlidePage,
			Banner1,
			Banner2,
			Banner3,
			Banner4,
			Banner5,
			Banner6,
			Banner7,
			Banner8
		},
		props: {
			useAnimation: true,
			refresh: true,
			useWheel: true,
			useSwipe: true
		},
		mounted() {
			    //给页面绑定滑轮滚动事件
			    // if (document.addEventListener) {
			    //     document.addEventListener('DOMMouseScroll', this.scrollFunc, false);
			    // }
			    // //滚动滑轮触发scrollFunc方法
			    // window.onmousewheel = document.onmousewheel = this.scrollFunc;
		},
		watch: {
			curPage: {
				handler(newvalue, oldvalue) {
					if (this.curPage == '5' || this.curPage == '6' || this.curPage == '7') {
						this.commonfontColor = 'font_black'
					} else {
						this.commonfontColor = 'font_white'
					}
				}
			}
		},
		data () {
			return {
				options: {
					 menu: '#menu',
					      navigation: false,                                     //右边的小圆点导航
						  // afterLoad: this.afterLoad,
						  onLeave: this.beforeLoad,
						  // beforeLoad: this.beforeLoad,
						  refresh: true,
						  scrollingSpeed: 1000,
						  licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE'
				},
				curPage: 1,
				cando: true,
				commonfontColor: 'font_white', // font_black
				aniDownUp: '' // 默认为空，向下滑动，则向下，向上滑动则向上
			}
		},
    mounted () {
      this.changeLangue()
    },
		methods: {
			beforeLoad (origin, destination, direction) {
				// console.log(origin, 'origin')
				// console.log(destination, 'des')
				// console.log(direction, 'direction')
				this.curPage = destination.index + 1
				this.aniDownUp = direction
			},
			// afterLoad (old, target) {
			// },
			scrollFunc (e) {
				// console.log(e)
			    if (e.wheelDeltaY > 0) { //当滑轮向上滚动时
					if (this.curPage > 1 && this.cando) {
						this.curPage -= 1
						this.$refs['slideContainer'].slideTo(this.curPage)
					}
			    }
			    if (e.wheelDeltaY < 0) { //当滑轮向下滚动时
					if (this.curPage < 8 && this.cando) {
						this.curPage += 1
						this.$refs['slideContainer'].slideTo(this.curPage)
					}
			    }
			},
			onBefore(origin, direction, target) {
				this.cando = false
			},
			changeIndex (origin, direction, target) {
				// console.log('cando')
				setTimeout(() => {
				    this.cando = true
				},800)
			},
			clickDocument () {
				this.cando = true
			},
			// 切换语言
			changeLangue () {
				let locale = this.$i18n.locale
				// locale == 'cn' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'cn'
				locale == 'en' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'en'

				// if (locale)
				localStorage.setItem('user_lang', this.$i18n.locale)
			},
			gotoIndex (index) {
				// console.log(index, '目前点击')
				this.curPage = index
				this.$refs['slideContainer'].api.moveTo(index)
				
			}
		}
	}
</script>

<style lang="scss">
	/deep/ .slider-btn {
		display: none !important;
	}
	body {
		height: 100vh;
		// background-color: forestgreen;
	}
	.slide-page {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100vw;
	  height: 100vh;
	  overflow-y: auto;
	  overflow-x: hidden;
	  -webkit-overflow-scrolling: touch;
	  -webkit-tap-highlight-color:rgba(255,255,255,0);
	  -webkit-text-size-adjust: none;
	  -webkit-backface-visibility:hidden;-webkit-transform-style:preserve-3d;
	  background-position: center;
	  transform: translate3d(0,100%,0);
	  -webkit-transform: translate3d(0,100%,0);
	}
	.slide-page.transition {
	  transition: all 500ms cubic-bezier(0.550, 0.085, 0.000, 0.990);
	  -webkit-transition: all 500ms cubic-bezier(0.550, 0.085, 0.000, 0.990);
	}
	#pc {
		margin: 0;
		width: 100vw;
		height: 100vh !important;
		min-height: 100vh;
		padding: 0;
		box-sizing: border-box;
		position: relative;
		font-family: 'PilatTest-Bold';
		// background-color: red;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}
	.font_black {
		color: #000;
	}
	.font_white {
		color: #fff;
	}
	.curBorderW {
		border-bottom: 2px solid #fff;
		height: 0.68rem;
		display: block;
		cursor: pointer;
	}
	.curBorderB {
		border-bottom: 2px solid #000;
		height: 0.68rem;
		display: block;
		cursor: pointer;
	}
	.topheader8 {
		// background-color: red;
		height: 100px;
		padding: 1.25rem;
		font-size: 3.25rem;
	}
	.topheader {
		position: fixed;
		top: 0rem;
		width: 100%;
		height: 100px;
		padding-bottom: 0;
		z-index: 999;
		text-align: left;
		display: flex;
		justify-content: space-between;
		font-family: 'PilatTest-Bold';
		font-size: 0.50rem;
		font-weight: 700;
		box-sizing: border-box;
		padding-left: 1.5625rem;
		margin: 0;
		.toheader_left {
			width: 80%;
			display: flex;
			justify-content: flex-start;
			cursor: pointer;
			.headerlogo {
				line-height: 3.5rem;
				position: relative;
				box-sizing: border-box;
				padding-left: 3.5rem;
				// height: 0.8rem;
				img {
					position: absolute;
					width: 2.7rem;
					top: 50%;
					transform: translateY(-50%);
					left: 0;
				}
			}
			span {
				display: inline-block;
				padding-top: 40px;
				vertical-align: bottom;
				margin-right: 1.25rem;
				padding-bottom: 0;
				margin-bottom: 0;
				vertical-align: bottom;
				// height: 39px;
			}
			.curBorderW {
				border-bottom: 2px solid #fff;
				cursor: pointer;
			}
			.curBorderB {
				border-bottom: 2px solid #000;
				display: inline-block;
				cursor: pointer;
				
			}
			span {
				display: inline-block;
			}
		}
		.right_text {
			display: inline-block;
			padding-top: 50px;
			font-size: 0.35rem;
			vertical-align: bottom;
			margin-right: 1.25rem;
			padding-bottom: 0;
			margin-bottom: 0;
			vertical-align: bottom;
			height: 39px;
		}
		.header_logo_icon {
			font-size: 0.25rem;
			font-style: normal;
			vertical-align: super;
			margin-left: -5px;
		}
	}
	.topheadercn {
		// font-size: 0.47rem;
		// line-height: 30px;
	}
	.full-page {
		padding: 0;
		margin: 0;
	}
</style>
